export const OPENTABLE_NEW_AGENT_UI_COPY = {
  websiteUrl: {
    title: 'Let us set up your agent from your website',
    description:
      "Paste your website and we'll pre-fill your agent with the details guests ask about most: opening hours, location, policies, FAQs and contact details.",
    placeholder: 'https://yourrestaurant.com',
  },
} as const;
